export const faqs = [
    {
        heading: `Supchain`,
        subHeading: "",
        questions: [
            {
                question: `Where is Supchain based?`,
                answer: `<p><b>Headquarter</b></p>
                <p>Wefreelancer Global Tech, Inc. <br>
                6000 Park of Commerce BLVD <br>
                Suite C <br>
                Boca Raton, Florida 33487 United States </p>
                
                <p><b>Germany office</b></p>
                <p>Wefreelancer GMB <br>
                Rheinstrasse 11 <br>
                Berlin , 10178, Germany </p> <br>
                
                <p> How to Obtain Instruction <br>
                Follow the instruction on <Link to="how-to-obtain">How to Obtain page<Link> </p>`,
            },
            {
                question: `What are the presale and launch dates?`,
                answer: `<p> The SUPC presale will run from the last week of December in predefined stages until it sells out. Once the presale ends, buyers will be able to claim the SUPC from the website at the same time as the token is listed on the first exchange. All claim and launch dates will be announced on our social media channels. </p>`,
            },
            {
                question: `What are the SUPC tokenomics?`,
                answer: `<p><b>Token Information</b></p> <br>

                <p>Token Name: Supchain </p>
                <p>Token Symbol: $UPC </p>
                <p>Decimal: 18 </p>
                <p>Total Supply: 10,000,000,000 </p>
                <p>Hardcap: $14,250,000  </p>
                <p>Blockchain: Ethereum </p>
                <p>Offer: Token Sale via ICO </p> <br>
                
                <p><b>Token Allocation </b></p>
                <p> Total Supply: 10,000,000,000 </p>

                <ul style="list-style: none"> 
                    <li>&rarr; Token Sale ⇒ 23% </li>
                    <li>&rarr; Marketing ⇒ 10% </li>
                    <li>&rarr; Development ⇒ 15% </li>
                    <li>&rarr; Staking  ⇒ 12% </li>
                    <li>&rarr; Initial Liquidity ⇒ 1.5% </li>
                    <li>&rarr; Airdrop ⇒ 0.2% </li>
                    <li>&rarr; Team ⇒ 10% </li>
                    <li>&rarr; Ecosystem ⇒ 22.8% </li>
                    <li>&rarr; Supelle Treasury ⇒ 5.5%  </li>
                </ul>
                <p> Presale Starting Price: $0.0045 </p>
                
                `,
            },
            {
                question: `Which network hosts the Supchain token?`,
                answer: `<p>  The Supchain token is hosted on the Ethereum network. Various purchasing methods are available. </p>`,
            },
            {
                question: ` When will Supchain be listed, and at what stage is the project currently?`,
                answer: `<p>Supchain will be listed upon completion of the presale. We have structured the presale from seed stages to presale 2 and public.</p>`,
            },
            {
                question: `How does the Supchain presale work?`,
                answer: `<p>The Supchain presale is structured in a few stages. Each stage has a specific number of tokens allocated for sale. Once we sell all tokens in a stage, we transition to the next one. Currently, we're in the seeding stage (as of x date) </p>`,
            },
            {
                question: `Why can't I buy with ETH on Trustwallet?`,
                answer: `<p>Please check the browser you're using. If you're using Chrome, Safari, or Firefox browser, try clearing the cache. If not, consider using Trustwallet's in-built browser. If it still doesn't work, you can try buying with Metamask's built-in browser; we have received far fewer complaints with Metamask. </p>`,
            },
            {
                question: `Will I receive the tokens immediately after purchase or only upon release?`,
                answer: `<p>After your purchase, your tokens will be visible on the buy widget after connecting your wallet. Additionally, you would be able to check your balance. If you don't see your balance, reach out to support help@Supchain.io </p>`,
            },
            {
                question: `Do I need to claim my tokens?`,
                answer: `<p>Yes, you will need to claim your tokens right before the launch. Please note it is normal not to see any tokens in your wallet at the moment. </p>`,
            },
            {
                question: `Why aren't my tokens showing in my wallet after purchase?`,
                answer: `<p>Currently, your tokens will not appear in your wallet but will be visible on the holder's app on our website. You will be able to claim them shortly before listing. If you don't see your balance, reach out to support  help@Supchain.io </p>`,
            },
            {
                question: `Do I need to create a personal wallet outside exchanges to buy the token?`,
                answer: `<p>Yes, we recommend using Metamask. Please be aware that no one from the Supchain team will ever DM you first. Stay vigilant against scams. </p>`,
            },
            {
                question: `What if I'm not able to complete a transaction?`,
                answer: `<p>If you're using an inbuilt browser within your wallet, try clearing the cache. Do not click on any links sent to you unsolicited. </p>`,
            },
            {
                question: `Where will the Supchain coin be publicly launched?`,
                answer: `<p>The Supchain coin will public launch on DEX (Uniswap), with more listings to follow. </p>`,
            },
            {
                question: `What is the contract address for Supchain?`,
                answer: `<p>The contract address is: </p>`,
            },
            {
                question: `Who has audited the Supchain project?`,
                answer: `<p>The Supchain project has been audited and passed KYC by CoinSult. You can view the report on their GitHub page: </p>`,
            },
            {
                question: `How are the funds raised during the Supchain presale used?`,
                answer: `<p>The funds raised during the Supchain presale are contributed  back into the project to support development, marketing, DOA, and other operational expenses. </p>`,
            },
            {
                question: `What is the significance of the Supchain project?`,
                answer: `<p>The strong performance of Supchain amid a broader market downturn underscores the confidence contributors have in our project. It's a testament to our robust ecosystem and global marketplace driven by our mission and strategic value it brings to the crypto market. </p>`,
            },
            {
                question: ` What are the benefits of participating in the Supchain presale?`,
                answer: `<p>Participating in the Supchain presale provides an opportunity to acquire our tokens at a lower price, like a backdoor opportunity, before they're listed on exchanges. Early supporters often have the potential for significant gains if the project performs well. Supelle’s marketplace makes this project a must-buy. </p>`,
            },
            {
                question: ` How can I stay updated on the progress of Supchain?`,
                answer: `<p>A: We recommend following our official Twitter account, @Supellecoin, for real-time updates. You can also visit our website, Supchain.io, for comprehensive information about our project. </p>`,
            },
            {
                question: `What makes Supchain different?`,
                answer: `<p>Supchain is committed to cultivating an ecosystem that values loyalty. As a testament to our dedication, we’re giving back by sharing a portion of our revenue through buybacks for the SUPC token </p>`,
            },
            {
                question: `How long does the presale last? `,
                answer: `<p>The presale will be open when the hard cap is reached. SUPC has no soft cap for this project. </p>`,
            },
            {
                question: `Why should I buy Supchain?`,
                answer: `<p>SUPC is a lifetime groundbreaking opportunity to have a fair chance to be a part playing a role with many top cryptocurrencies in the world's early stage, a rare find. Only Supchain will give you access to incredible early bird, both from staking and just holding SUPC tokens. </p>`,
            },
            {
                question: `Does the presale have a vesting period?`,
                answer: `<p>Yes, Supchain offers a very brilliant vesting program for our supporters </p>`,
            },
            {
                question: `When will the token launch?`,
                answer: `<p>We will launch SUPC within days of the presale ending. We will keep everyone informed of the launch day through our website and social media outlets. </p>`,
            },
        ]
    },
    {
        heading: `Account Opening`,
        subHeading: "Opening an account on MetaMask & Trust Wallet",
        questions: [
            {
                question: `How do I open a account?`,
                answer: `
                <p><b>Getting Started In Crypto</b></p>
                
                <p>"Are you new to crypto token purchasing? No need to fret! We've prepared a comprehensive guide on setting up a personal wallet and acquiring SUP tokens right here. Our presale is conveniently hosted on our website, making it accessible through a browser-based or mobile app wallet </p>
                <p>In the vast realm of crypto wallets, numerous options await your exploration. We encourage you to conduct thorough research, but for a reliable choice, we highly recommend MetaMask or Trust Wallet. These brands stand out as widely acclaimed and trusted within the industry, offering secure storage, seamless transactions, and efficient receipt of cryptocurrencies"</p>

                <p> PC  & Laptop Users </p>

                Get the MetalMask browser extensing
                <ul style="list-style: none">
                    <li>MetaMask is a self-custody wallet that only you control. Visit the ​MetaMask website and install the extension for your preferred browser. The most common are Chrome and Firefox. </li>
                </ul>

                Create your new wallet
                <ul style="list-style: none">
                    <li> After installing MetaMask, click on‘Create a Wallet’. Your wallet is a public key comprising randomly generated numbers and letters. This is your identifier on the blockchain, like a bank account number for your crypto.</li>
                </ul>

                Set a password for your wallet
                <ul style="list-style: none">
                    <li>Next, create a password to log in to your wallet. Choose a secure password with letters, numbers, and special characters. Try to use a different password to your others. </li>
                </ul>

                Save and write down the recovery phrase
                <ul style="list-style: none">
                    <li>Before you do anything else, write down your 12-word recovery phrase on a piece of paper and keep it in the safest place possible. Don’t store it on the same device you use to access your wallet! You’ll need this recovery phrase if you ever lose access to your wallet. </li>
                </ul>

                Use the Ethereum or BNB Chain network
                <ul>
                    <li>By default, MetaMask is set to transact on the Ethereum network. You can purchase Wall Street Memes (SUPC) using ETH as soon as you buy or send some ETH to your MetaMask public address. ETH is needed to pay for gas fees for every transaction. </li>
                    <li>If you wish to buy SUPC tokens using BNB, read this guide on how to add the BNB Chain network to your MetaMask wallet. BNB serves the same purpose as ETH and is needed to pay for gas on BNB Chain. </li>
                </ul>

                Claiming your SUPC tokens
                <ul>
                    <li> After buying SUPC tokens, you can see how much you’ll be able to claim on the website’s home page. After the presale, once claiming is activated, you’ll be able to claim your SUPC tokens to the same MetaMask wallet address you used to contribute.</li>
                </ul>

                Import SUPC to MetaMask
                <ul>
                    <li> After buying SUPC tokens, you can see how much you’ll be able to claim on the website’s home page. After the presale, once claiming is activated, you’ll be able to claim your SUPC  tokens to the same MetaMask wallet address you used to contribute.</li>
                </ul>

                <p><b>Phone & Tablet</b></p>

                Get the Trust Wallet app
                <ul>
                    <li>There are many mobile wallets out there, but Trust Wallet is widely recommended. Download the app from your preferred app store, depending on your mobile device. </li>
                </ul>

                Start a new wallet.
                <ul>
                    <li> Click on the ‘Create a Wallet’ button to start a new wallet that you can use on your mobile phone. Set a new password if prompted to do so.</li>
                </ul>

                Save your passphrase
                <ul>
                    <li>This step is very important! Write down your 12-word backup passphrase. Then manually type the 12 words in the correct sequence. You’ll need this passphrase to regain access to your wallet on a different device should you ever lose access. </li>
                </ul>

                Use Ethereum or BNB Chain
                <ul>
                    <li>Trust Wallet supports transactions on Ethereum or BNB Chain. You can purchase Wall Street Memes (SUPC) using ETH or BNB as soon as you buy or send some ETH or BNB to your Trust Wallet address. ETH or BNB is needed to pay gas fees for every transaction. </li>
                </ul>

                Claiming your SUPC tokens
                <ul>
                    <li>After buying SUPC tokens, you can see how much you’ll be able to claim on the website’s home page. After the presale, once claiming is activated, you’ll be able to claim your SUPC tokens to the same Trust Wallet address you used to contribute.</li>
                </ul>

                Add SUPC to Trust Wallet
                <ul>
                    <li>To view your token balance within Trust Wallet, add the SUPC token to your wallet. Click on the dotted button in the top-right of the screen, followed by ‘Add Custom Token.’ Paste the SUPC contract address:</li>
                </ul>
                `,
            },

        ]
    },
    {
        heading: `MetaMask.`,
        subHeading: "For utility tokens trading.",
        questions: [
            {
                question: `What is Metamask and why do I need it?`,
                answer: `<p>Metamask is an Ethereum wallet that can be used to hold ERC Ethereum-based tokens, such as the Supchain token. It is currently the only wallet that is supported for trading utility tokens on the Supelle platform. <br>
                
                To trade utility tokens, you will be required to link a MetaMask wallet address to your Supelle account. <br>
                
                The seller’s wallet must hold the tokens being sold. The buyer also needs to have a linked MetaMask wallet to their Supelle account as this is where the purchased tokens will be sent on the blockchain. <br>
                
                For a list of supported browsers and how to set up your MetaMask wallet in a few minutes, watch this video from MetaMask or visit their Help Center here.</p>`,
            },
            {
                question: `Linking your MetaMask wallet with your Supelle account`,
                answer: `<p>Trading utility tokens requires you to connect a unique MetaMask wallet. This will be the only wallet with which you can trade Supchain on the platform. Before connecting to a MetaMask wallet, please add the MetaMask extension to your browser:
                 </p>
                 
                <ol>
                    <li>Visit <a href="https://metamask.io">https://metamask.io<a></li>
                    <li>Click on the link to add the extension to your browser and follow instructions from MetaMask</li>
                    <li>Once you have MetaMask installed, refresh the browser</li>
                </ol>
                
                <p>After choosing to trade Supchain on the Supelle platform, you will be requested to link your MetaMask wallet.<br>

                Click on the ‘Link’ button, enter your MetaMask password into the Metamask popup, choose the wallet address you wish to link, and click on ‘Connect’.<br>
                
                Review the wallet details presented in the Supelle confirmation pop-up and confirm. The selected MetaMask wallet is now linked to your Supelle account.<br> 
                
                Note: Once your wallet address is linked, it cannot be changed. 
                 </p>`,
            },
            {
                question: `Allowing tokens to be moved from your MetaMask wallet`,
                answer: `<p>When choosing to trade Supchain, the Ethereum blockchain will require that you first approve Supelle to move tokens in and out of your wallet.<br>

                This approval requires you to have Ethereum in your wallet to be able to pay the transaction fee to the network.<br>
                
                Once you hit the ‘Confirm’ button on the MetaMask extension, you will be able to monitor the approval transaction by visiting the ‘Activity’ section of your MetaMask wallet.<br>
                
                Once the allowance has been granted successfully, you will be able to place a sell order.
                </p>`,
            },
            {
                question: `What is a token allowance and how does it work?`,
                answer: `<p>Token allowance is a commonly used feature of blockchain transactions. It is needed for Supelle to move your tokens if they are sold. Token allowance is granted using the ‘ERC20 approve’ method, which allows an address to transfer tokens, without revealing the private key of your wallet.</p> 

                <p>Before selling your utility tokens, you must grant an allowance for each token separately. This allows Supelle to transfer tokens from your wallet to the buyer’s wallet.</p>
                
                <p>To grant an allowance, simply click the ‘Grant allowance’ button. This will prompt your Metamask extension to open. In your Metamask extension, click ‘Confirm’ and wait for the process to be completed.</p>
                
                <p>The transaction is done on the Ethereum blockchain, which means it costs gas fees and may take a few minutes.</p>
                
                <p>By default, the allowance amount is set to allow future orders without needing to grant additional allowances. This simplifies the trading process and reduces the amount of gas fees you will need to pay as a result of granting multiple allowances. If you choose to edit the allowance, this can be done through the Metamask interface by clicking on ‘Edit Permission’.</p>
                `,
            },
            {
                question: `Adding Supchain to your MetaMask wallet`,
                answer: `<p>Your Supchain balance is displayed on Supelle; however, Supelle does not have custody of your tokens. Supchains are custodied in your Metamask wallet</p>
                
                <p>Note: Even after buying tokens on the Supelle platform, they may not show up until the below steps are completed:</p>
                <ul> 
                    <li>Log in to your MetaMask wallet </li>
                    <li>Click on the Supchain contract address here to view it on Etherscan  </li>
                    <li>On the right-hand side, click on the MORE button to reveal the drop-down list </li>
                    <li>Select Add Token to MetaMask (Web3) </li>
                    <li>Click on the ‘Add Token’ button and that’s it. Existing tokens will show up in the wallet and new ones will be visible once bought and after the trade settles. </li>
                <ul>`,
                
            },
            {
                question: `Can I change the MetaMask wallet associated with my account?`,
                answer: `<p>Once your Metamask wallet address is linked, this is the only address that can be used to trade Supchain (utility tokens).</p>

                <p>Addresses can be changed in certain cases, mainly related to the security of your Metamask wallet. If you feel this applies to you please contact support at <a href="http://supchain.io/support/index.html">http://supchain.io/support/index.html. </a>.</p>
                
                `,
            },
            {
                question: `What does ‘speed-up’ mean in the Metamask wallet?`,
                answer: `<P>The wallet allows you to increase the payment to miners who approve your blockchain request. If you decide to speed up the allowance, you will have to decide on how much more you are willing to pay for the increased speed of approval. Increased ETH (gas) payment will speed up the process. This is the nature of blockchain transactions. </P>`,
            },
            {
                question: `Can I connect multiple Metamask addresses?`,
                answer: `<p>No, you can only select one Metamask address to be linked and that address will be whitelisted on the blockchain. As only whitelisted wallets can hold digital tokens, it is important to link the address you want to use for tokens trading. 

                While you can only trade from one linked MetaMask address, you can whitelist several addresses. Click here for more information on this. </p>`,
            },
        ]
    },
    {
        heading: `Whitelisting`,
        subHeading: "Whitelisting.",
        questions: [
            {
                question: `What is whitelisting?`,
                answer: `<p>Whitelisting a wallet address with Supelle means that the holder has been duly identified through the Company’s KYC/AML procedures and the address is now registered in our whitelisting database. </p>`,
            },
            {
                question: `Why is whitelisting necessary?`,
                answer: `<p>In order to verify that Supchain are transferred between KYC/AML-approved users, transfers of utility tokens will be executed by the relevant smart contract under conditional permission. For transfers of utility tokens to be successful, the wallet addresses of both the seller and buyer need to be listed on the “Whitelist Database” of Supchain. </p>
                <p>This feature allows clients to have greater control over their utility token trading activities and ensures that their tokens are being transferred to safe and secure wallets.
                </p>`,
            },
            {
                question: `How do I whitelist my wallet?`,
                answer: `<p>If you have a linked Metamask wallet to your Supelle account, go to the trading screen. Click on the ‘Whitelist’ button and the process will start automatically once the wallet has been successfully connected.</p>

                <p>You can also whitelist your wallet through the portal available on our website. If you participated in the IPO, please use the same username and password to log into your account. If any additional information is needed, you will be contacted.</p>
                
                <p>If you are NOT a token holder already, you must create an account using your email address. Please follow the on-screen instructions to upload the documents needed for KYC/AML verification. If any additional information is needed from you, our support team will get in touch.</p>
                `,
            },
            {
                question: `Which wallets can I whitelist?`,
                answer: `<p>The ideal wallet to whitelist with Supelle is a non-custodial ERC 20 compatible account that supports the addition of custom tokens. The only option at this time is: <a href="https://metamask.io/">https://metamask.io/ </a> </p>

                <p>Metamask is the only wallet that can be used for Supchain trading on Supelle, but other wallets can be whitelisted to hold in cold storage.</p>
                
                <p>Any wallet address associated with an exchange (Binance, Kraken, Gemini, Crypto.com, Coinbase.com) will not be able to receive Supcoin.</p>
                
                <p>Please note that if you wish to sell or purchase Supchain on the secondary market you will need to whitelist a Metamask wallet address, as this is the only wallet provider that custodies Supchain.</p>
                `,
            },
            {
                question: `What happens if you transfer Supchain tokens to a wallet that has not been whitelisted?`,
                answer: `<p>If either the seller’s or buyer’s wallet address is not listed in the Whitelist Database (or if the Company has “frozen” the user’s wallet address), the smart contract rejects the transfer and the Supchain Token Distributed Ledger is not updated. </p>`,
            },
           
        ]
    },
    {
        heading: `Regulation`,
        subHeading: "Regulation.",
        questions: [
            {
                question: `Who do I contact If I want to raise capital at Supelle?`,
                answer: `Please contact us at <a href="http://supchain.io/support/index.html" target="_blank"> http://supchain.io/support/index.html</a>`,
            },
            {
                question: `What are U.S. Regulatory Holder Count Limits?`,
                answer: `<p>U.S. regulations limit the number of U.S. holders for certain types of tokens and issuers have the discretion to further limit holder counts.</p>

                <p>If a token is at its limit for U.S. holders, U.S. Users will only be able to bid if they are already holders of the token. Bids will not be accepted from U.S. Users not currently holders of the token until the holder count is below its limit.</p>
                
                <p>Any open bid orders by U.S. Users not currently holders of the token will be canceled when a token reaches its U.S. holder limit.</p>
                `,
            },
            {
                question: `Are the tokens traded on Supelle reporting to the SEC on a quarterly or annual basis?`,
                answer: `<p>This depends on the type of registration or exemption the issuer has used. Please check with the issuer for the most current information. </p>`,
            },
            {
                question: `Does Supelle provide tax reporting for Users such as 1099 forms?`,
                answer: `<p>No, Supelle does not.</p>

                <p>You are required to report any sales, conversions, payments, and income to the IRS. In addition, all users self-custody their tokens and are therefore responsible for tracking their own tax reporting such as capital gains and losses. You may request a report of your activity from us at  <a href=" http://supchain.io/support/index.html" target="_blank">  http://supchain.io/support/index.html</a>. It is up to you to track cost basis information, especially for crypto activity that was transferred to Supelle from other exchanges and/or wallets. For additional requirements, please consult your accountant.</p>`,
            },
        ]
    },
    {
        heading: `General`,
        subHeading: "General.",
        questions: [
            {
                question: `What is the difference between cryptocurrencies and utility tokens?`,
                answer: `<p>Cryptocurrencies and utility tokens are both types of digital assets that use blockchain technology, but they serve different purposes within their respective ecosystems.</p>

                <p>Cryptocurrencies, such as Bitcoin or Ethereum, are designed to function as digital currencies that can be used as a medium of exchange. They aim to serve as a decentralized form of money, enabling secure and direct peer-to-peer transactions without the need for intermediaries like banks. Cryptocurrencies often operate on their own blockchain networks and are generally used for storing value, making payments, or speculating on their price movements.</p>
                
                <p>On the other hand, utility tokens like Supcoin are specific to a particular blockchain-based platform or application. These tokens are created to provide access to the features, products, or services offered by the platform. Utility tokens act as a unit of value within the ecosystem and enable users to participate in various activities, such as accessing premium features, receiving discounts, or obtaining specific rights or privileges.</p>
                `,
            },
            {
                question: `What is a blockchain?`,
                answer: `<p>Blockchains are linked blocks of data and each new block contains new information which is added, shared, and stored by many computers on a network. For example, if you buy Bitcoin, the record of your ownership is stored in a new block of data on the Bitcoin blockchain, and all computers that are part of that Bitcoin network share and add that new block to the existing chain of blocks. Different cryptocurrencies mostly run on their respective blockchains. ETH runs on the Ethereum blockchain and so on.</p>

                <p>To hold a digital asset on a blockchain, Contributors need a digital wallet which is a secure and unique address on the blockchain.</p>
                
                <p>The benefits of blockchains apply to many industries including Financial Services where, for example, blockchain technology has created the ability to instantly send and receive (instant settlement) cryptocurrencies across international boundaries. The traditional banking models typically take 1-2 days for settlement.</p>
                
                <p>Cryptocurrency and Utility Token transactions can be monitored on a blockchain explorer for real-time or historical confirmation of completion, status, or delays.</p>
                `,
            },
            {
                question: `What is a blockchain explorer?`,
                answer: `<p>Transactions and wallet addresses on a public blockchain can be viewed using a blockchain explorer.</p>

                <p>Since blocks of data on the chain are shared by numerous computers on the network, the data including transactions, sender and receiver wallet addresses, time, and date are also available for public access using explorers, many of which are open source or provided by third parties.</p>
                
                <p>A notable blockchain explorer is Etherscan which can be used to monitor transactions on the Ethereum blockchain. Enter a wallet ID or transaction ID or contract address in the search bar for results.</p>
                
                <p>A Google search for LTC explorer or ZEC explorer will yield multiple results for user-friendly explorers of those blockchains.</p>
                `,
            },
            {
                question: `What is FIAT currency and what is Cryptocurrency?`,
                answer: `<p>FIAT money is a legal tender like the US ($) dollar or Euro (€) that is tied to a government-issued currency. FIAT can be used as physical notes or electronic payments using online banking and debit or credit cards. FIAT currency is backed by a central government and its supply is also controlled by the government.</p>

                <p>Cryptocurrency is a purely digital asset that is created on and derives value from its native blockchain. Cryptocurrency is a decentralized asset governed by cryptography and its supply is controlled by an algorithm. Common examples are Litecoin (LTC), Bitcoin (BTC), and Ether (ETH).</p>
                `,
            },
            {
                question: `What are the risks of contributing in cryptocurrencies?`,
                answer: `<p>Contributing and trading in all financial markets carries risk. Cryptocurrencies are not exempt from this and supporters and traders should never back more money than they can afford to lose.</p>

                <p>Supelle does not provide investment, legal, or tax advice, and we provide this information for educational purposes only and all users of cryptocurrencies and digital assets are encouraged to conduct their own due diligence before opening an account and/or buying, selling, or trading cryptocurrencies and digital assets.</p>
                
                <p>You must evaluate your particular financial circumstances to determine whether or not trading cryptocurrencies is appropriate for you. You should not back funds in cryptocurrencies that you cannot afford to lose. The trading of cryptocurrencies can result in substantial losses, including most or all of your contribution.</p>

                Here are some of the numerous risks associated with cryptocurrency trading
                <ul>
                    <li>Cryptocurrencies are volatile and often see sharp and sudden moves due to many reasons including market sentiment</li>
                    <li>Regulatory changes and differences from country to country may adversely affect cryptocurrency prices and liquidity</li>
                    <li>Some cryptocurrencies are highly correlated to others and may see sudden price movements as a result</li>
                    <li>Cryptocurrencies are susceptible to cryptographic errors and hackers</li>
                    <li>Cryptocurrencies may be discontinued or abandoned or split through hard-forks</li>
                    <li>Transactions may be irreversible and losses due to fraudulent or accidental transactions may not be recoverable</li>
                </ul>
                <p>For more information about the risks associated with cryptocurrencies and other digital assets, check out our <a href="https://www.supchain.co/legal/risk-disclosure-2/index.html" target="_blank">Risk Disclosure.</a> </p>
                `,
            },
            {
                question: ``,
                answer: ``,
            },
        ]
    },
]